import Swal from 'sweetalert2';

export default function errorMessage(errorTitle, errorMessage) {
    return  Swal.fire({
        title: errorTitle,
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Close'
    });
}